import { ICollaboratorsState } from '@/modules/collaborators/store/collaborators';

const ICollaboratorsState: ICollaboratorsState = {
    listUserInvite: [],
    listHistoriesCollaborators: []
};
export default ICollaboratorsState;
